import script from "./QrcodePayconiq.vue?vue&type=script&setup=true&lang=js"
export * from "./QrcodePayconiq.vue?vue&type=script&setup=true&lang=js"

import "./QrcodePayconiq.vue?vue&type=style&index=0&id=7de0d130&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de0d130"]])

export default __exports__